// src/config/constants.js
import { ABIS } from './abis';

// ============ CONFIGURATION ============
export const CONFIG = {
  // Public RPC URL for Base Sepolia
  RPC_URL: "https://sepolia.base.org",
  
  // Optional: Fallback RPCs for reliability
  FALLBACK_RPCS: [
    "https://sepolia.base.org",
    "https://base-sepolia.publicnode.com",
    "https://base-sepolia.g.alchemy.com/v2/demo"
  ],
  
  // Chain configuration
  CHAIN_ID: 84532, // Base Sepolia
  
  // Contract addresses
  ADDRESSES: {
    NFT: '0x9418fB8bDC0C76Ea6aDd5eAe2c4f1cb22267D767',
    COIN: '0xE49c58649F3bF2d2af85d3013F4691f6299FA7F8',
    STAKING: '0x2A636631F389985Ef14158aC3ff0A0Af5232315d'
  },
  
  // Chain info for UI display
  CHAIN_INFO: {
    name: "Base Sepolia",
    explorer: "https://sepolia.basescan.org",
    currency: "ETH",
    testnet: true
  }
};

// Export ABIs from separate file
export { ABIS };

// ============ STYLES ============
export const STYLES = {
  gradients: {
    primary: 'linear-gradient(135deg, #0066cc 0%, #0044aa 100%)',
    success: 'linear-gradient(135deg, #00ff00 0%, #00cc00 100%)',
    danger: 'linear-gradient(135deg, #ff3366 0%, #cc0044 100%)',
    dark: 'linear-gradient(145deg, #0a0a0a 0%, #1a1a1a 100%)',
    light: 'linear-gradient(145deg, #f5f5f5 0%, #ffffff 100%)'
  },
  shadows: {
    glow: '0 0 20px rgba(0, 255, 0, 0.3)',
    solid: '8px 8px 0 0 rgba(255, 255, 255, 0.8)',
    combined: '0 0 20px rgba(0, 255, 0, 0.3), 8px 8px 0 0 rgba(255, 255, 255, 0.8)'
  }
};